/**
 * Retrieves the submission GUID from the URL or localStorage.
 * @returns {string|null} The submission GUID, or null if not found.
 */
export function getSubmissionGuid() {
    const urlParams = new URLSearchParams(window.location.search);
    let submissionGuid = urlParams.get("submission_guid");

    if (!submissionGuid) {
        submissionGuid = localStorage.getItem("_ag_SGUID");
    } else {
        localStorage.setItem("_ag_SGUID", submissionGuid);
    }

    return submissionGuid;
}
